'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _index = require('@beisen/highcharts/lib/highchart/index.js');

var _index2 = _interopRequireDefault(_index);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

window.Highcharts = _index2.default;
var HighchartsAll = require('@beisen/highcharts/lib/highchart/highchartall.js');

var win = typeof global === 'undefined' ? window : global;

var ReactHighcharts = function (_Component) {
  _inherits(ReactHighcharts, _Component);

  function ReactHighcharts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactHighcharts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactHighcharts.__proto__ || Object.getPrototypeOf(ReactHighcharts)).call.apply(_ref, [this].concat(args))), _this), _this.getChart = function () {
      if (!_this.chart) {
        throw new Error('getChart() should not be called before the component is mounted');
      }
      return _this.chart;
    }, _this.renderChart = function (config) {
      if (!config) {
        return;
      }
      var chartType = config.type;
      var chartConfig = config.chart;
      var _config = (0, _objectAssign2.default)({}, config, {
        credits: {
          enabled: false
        }
      });
      _this.chart = new _index2.default[chartType || 'Chart'](_extends({}, _config, {
        chart: _extends({}, chartConfig, {
          renderTo: _this.refs.chart
        })
      }), _this.props.callback);
      if (!_this.props.neverReflow) {
        win && win.requestAnimationFrame && requestAnimationFrame(function () {
          _this.chart && _this.chart.options && _this.chart.reflow();
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactHighcharts, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.neverReflow || nextProps.isPureConfig && this.props.config === nextProps.config) {
        return true;
      }
      this.renderChart(nextProps.config);
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderChart(this.props.config);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.chart.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', _extends({ ref: 'chart' }, this.props.domProps));
    }
  }]);

  return ReactHighcharts;
}(_react.Component);

ReactHighcharts.defaultProps = {
  callback: function callback() {},
  domProps: {}
};


ReactHighcharts.PropTypes = {
  config: _react2.default.PropTypes.object.isRequired,
  isPureConfig: _react2.default.PropTypes.bool,
  neverReflow: _react2.default.PropTypes.bool,
  callback: _react2.default.PropTypes.func,
  domProps: _react2.default.PropTypes.object
};

// ReactHighcharts.Highcharts = Highcharts;
// ReactHighcharts.withHighcharts = (Highcharts) =>{
//   return module.exports(chartType, Highcharts);
// };

module.exports = ReactHighcharts;


//////////////////
// WEBPACK FOOTER
// ./~/@beisen/react-highcharts/lib/index.js
// module id = 223
// module chunks = 2